<template>
  <div class="app-preloader">
    <UiSpinner :size="40" class="app-spinner" />
  </div>
</template>

<script setup lang="ts">
import { UiSpinner } from '~/ui/index.js';
</script>

<style scoped>
.app-preloader {
  width: 100%;
  height: 100%;
  position: relative;
}

.app-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateY(-50%) translateX(-50%);
}
</style>
